import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api';
import { useAuth } from './AuthContext';

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user.role === 'admin') {
      setItems([]); setCount(0); setSubtotal(0); return;
    }
    setLoading(true);
    try {
      const { data } = await api.get('/cart');
      const list = data.items || [];
      setItems(list);
      setCount(list.reduce((s, it) => s + (it.qty || 0), 0));
      setSubtotal(Number(data.subtotal || 0));
    } catch (_) {
      setItems([]); setCount(0); setSubtotal(0);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // Refresh on user change + on any route change (cheap keep-in-sync)
  useEffect(() => { refresh(); }, [refresh, location.pathname]);

  return (
    <CartCtx.Provider value={{ items, count, subtotal, loading, refresh }}>
      {children}
    </CartCtx.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartCtx);
  if (!ctx) throw new Error('useCart must be inside CartProvider');
  return ctx;
}
